<template>
	<Modal :title="$t('modal.quiz.title')" :confirmText="$t('general.got-it')">
		<div class="p-4">
			<p>
				{{
					$org
						? $t('modal.quiz.text-organization')
						: $t('modal.quiz.text-applicant')
				}}
			</p>
			<img
				:src="`/test_${$org ? 'arbeitgeber' : 'arbeitnehmer'}.gif`"
				class="img-fluid"
			/>
		</div>
	</Modal>
</template>
<script>
import Modal from '~/components/ui/layout/Modal'

export default {
	components: {
		Modal
	},
	props: {
		$t: {
			type: Function
		}
	}
}
</script>
